import React from 'react';
import { HtmlIds } from '../../../../constants';
import { FaqsSection } from '../../../../components/FaqsSection';
import { wellnessPlanFaqsData } from '../../../../data/wellness-plan-faqs';
import { Box } from '../../../../wag-react/next-components/box';
import { Button } from '../../../../wag-react/next-components/button';
export const WellnessFAQSection = () => <FaqsSection useMarkdown items={wellnessPlanFaqsData} pt={0} footerText={<Box mt={4}>
        <Button href={`#${HtmlIds.WELLNESS_PLANS_SECTION}`} variant="contained">
          Compare plans
        </Button>
      </Box>} data-sentry-element="FaqsSection" data-sentry-component="WellnessFAQSection" data-sentry-source-file="index.tsx" />;